<div class="flex p-1">
  <mat-select
    id="map-toolbar-layers"
    class="modus-dropdown !w-[140px] !px-2 hover:bg-gray-0"
    panelClass="modus-dropdown-panel"
    [formControl]="layerOptionControl"
    disableRipple
    [modus-tooltip]="translations.changeBackground.tooltip.text"
  >
    <mat-select-trigger class="flex items-center h-8 min-w-[100px]">
      <md-icon class="mr-1 text-gray-8">layers</md-icon>
      {{ activeBaseLayer()?.displayName }}
    </mat-select-trigger>
    @for (item of baseLayers(); track $index) {
      <mat-option [value]="item.name">{{ item.displayName }}</mat-option>
    }
  </mat-select>
</div>

<!-- add icon buttons in a seperate div so flex wrap will break here -->
<div class="flex p-1">
  <button
    id="map-toolbar-pan"
    class="text-gray-8 ml-1"
    modus-icon-button
    [modus-tooltip]="translations.pan.text"
    color="secondary"
    (click)="panSelectClick()"
    [ngClass]="{ ' !bg-blue-pale !text-trimble-blue': panSelectActive() }"
  >
    <md-icon>hand</md-icon>
  </button>

  <button
    id="map-toolbar-select-rectangle"
    class="text-gray-8 ml-1"
    modus-icon-button
    [modus-tooltip]="translations.selectByRectangle.text"
    color="secondary"
    (click)="rectangleSelectClick()"
    [ngClass]="{ ' !bg-blue-pale !text-trimble-blue': rectangleSelectActive() }"
  >
    <md-icon>polygon_drag_rectangle</md-icon>
  </button>

  <button
    id="map-toolbar-select-polygon"
    class="text-gray-8 ml-1"
    modus-icon-button
    [modus-tooltip]="translations.selectByPolygon.text"
    color="secondary"
    (click)="polygonSelectClick()"
    [ngClass]="{ '!bg-blue-pale !text-trimble-blue': polygonSelectActive() }"
  >
    <md-icon>polygon_cone</md-icon>
  </button>

  @if (clipAndSaveEnabled()) {
    <button
      id="map-toolbar-clip-rectangle"
      class="text-gray-8 ml-1"
      modus-icon-button
      [modus-tooltip]="translations.clipByRectangle.text"
      color="secondary"
      (click)="clipRectangleClick()"
      [ngClass]="{ ' !bg-blue-pale !text-trimble-blue': clipRectangleActive() }"
    >
      <span class="relative inline-flex items-center justify-center">
        <md-icon>polygon_drag_rectangle</md-icon>
        <md-icon
          class="absolute bottom-0 right-0 flex h-[13px] w-[13px] items-center justify-center rounded-full bg-white !text-[13px] !leading-none"
          >scissors</md-icon
        >
      </span>
    </button>

    <button
      id="map-toolbar-clip-polygon"
      class="text-gray-8 ml-1"
      modus-icon-button
      [modus-tooltip]="translations.clipByPolygon.text"
      color="secondary"
      (click)="clipPolygonClick()"
      [ngClass]="{ '!bg-blue-pale !text-trimble-blue': clipPolygonActive() }"
    >
      <span class="relative inline-flex items-center justify-center">
        <md-icon>polygon_cone</md-icon>
        <md-icon
          class="absolute bottom-0 right-0 flex h-[13px] w-[13px] items-center justify-center rounded-full bg-white !text-[13px] !leading-none"
          >scissors</md-icon
        >
      </span>
    </button>
  }

  <button
    id="map-toolbar-zoom-in"
    class="text-gray-8 ml-1"
    modus-icon-button
    [modus-tooltip]="translations.zoomIn.text"
    color="secondary"
    (click)="zoomInClick.emit()"
  >
    <md-icon>zoom_in</md-icon>
  </button>

  <button
    id="map-toolbar-zoom-out"
    class="text-gray-8 ml-1"
    modus-icon-button
    [modus-tooltip]="translations.zoomOut.text"
    color="secondary"
    (click)="zoomOutClick.emit()"
  >
    <md-icon>zoom_out</md-icon>
  </button>

  <button
    id="map-toolbar-fit-to-view"
    class="text-gray-8 ml-1"
    modus-icon-button
    [modus-tooltip]="translations.fitToView.text"
    color="secondary"
    (click)="fitToViewClick.emit()"
  >
    <md-icon>expand</md-icon>
  </button>
</div>
